import React from 'react';
import { Link } from 'react-router-dom';
import { padNumericId } from '../utils';
import { ROUTES } from 'src/navigation';

type Props = {
  numericId: number;
  padStart?: number;
  text?: string | undefined;
};

const NumericIdLink: React.FC<Props> = ({ numericId, padStart, text }) => {
  const url = ROUTES.SIVA.IDEAS_AND_COMPANIES.COMPANY_DETAILS.INDEX(`${numericId}`);

  return <Link to={url}>{text ? text : padNumericId(numericId, padStart)}</Link>;
};

export default NumericIdLink;
